/**
 * Convert a 1-based column index to its Excel column letter.
 * `1 → A`, `2 → B`, `26 → Z`, `27 → AA`, …
 *
 * Kept small and dependency-free so it can be used from any module that
 * needs to build formulas referencing other columns by id.
 */
export function columnLetter(index: number): string {
  let n = index;
  let out = '';
  while (n > 0) {
    const rem = (n - 1) % 26;
    out = String.fromCharCode(65 + rem) + out;
    n = Math.floor((n - 1) / 26);
  }
  return out;
}

/**
 * Inverse of `columnLetter` — convert an Excel column letter (`A`, `Z`,
 * `AA`, …) back to its 1-based column index. Case-insensitive.
 * Used to parse `SheetImage.cell` string references (ex: `"L5"`).
 */
export function columnIndexFromLetter(letters: string): number {
  let index = 0;
  for (const ch of letters.toUpperCase()) {
    index = index * 26 + (ch.charCodeAt(0) - 64);
  }
  return index;
}
